import constants from '../constants/constants.json';
import { getLanguageFromCountry } from './getLanguageFromCountry';

export function getSelectedLanguage({
  lngCookie,
  locale
}: {
  lngCookie?: string;
  locale: string;
}): { full_language: string; iso_639_1: string; locale: string } {
  const selectedLanguage = constants.I18.SUPPORTED_LANGUAGES.find(
    language => language.toLowerCase() === lngCookie?.toLowerCase()
  );

  if (selectedLanguage) {
    return {
      full_language: selectedLanguage,
      iso_639_1: selectedLanguage.split('-')[0],
      locale
    };
  }

  const language = getLanguageFromCountry(locale);

  return {
    full_language: language.full_language,
    iso_639_1: language.iso_639_1,
    locale
  };
}
